"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** 自定义页面（拖拉装修）菜单路由 **/
var zdyDraggingRouter = {
  path: '/zdy-dragging',
  component: _layout.default,
  redirect: '/zdy-dragging/index',
  name: 'zdyDragging',
  alwaysShow: true,
  meta: {
    title: '页面配置',
    icon: 'documentation'
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/zdy_dragging/index.vue'));
      });
    },
    name: 'ZdyDraggingIndex',
    meta: {
      title: '自定义页面',
      icon: ''
    }
  }
  // 注意：configPage 是独立全屏页（脱离 Layout），已在内层隐藏路由中注册，
  // 不放在这里，避免被 Layout 包裹导致无法整屏显示。
  ]
};
var _default = exports.default = zdyDraggingRouter;